import $fetch from '@/services/client'
import type { CountryCode } from '@/services/schemas'

async function listDealers(countryIsocode: CountryCode, state?: string) {
  const response = await $fetch('mycontroller/list-dealers/json', {
    body: {
      filter_country_isocode: countryIsocode,
      filter_country_state: state || '',
    },
  })

  if (response.error) throw new Error(response.error.statusText + response.error.message)

  return response.data.data
}

export default listDealers
